// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import billCommitteeAssignmentEntity from './entities/bill-committee-assignment.json';
import billCommitteeAssignmentMenu from '../pages/bill-committee-assignment/menu.json';
import billCommitteeAssignmentFullForm from '../pages/bill-committee-assignment/forms/full.json';
import billCommitteeAssignmentContextForm from '../pages/bill-committee-assignment/forms/context.json';
import billCommitteeAssignmentMiniForm from '../pages/bill-committee-assignment/forms/mini.json';
import billCommitteeAssignmentLookupForm from '../pages/bill-committee-assignment/forms/lookup.json';
import billCommitteeAssignmentTableView from '../pages/bill-committee-assignment/views/table.json';
import billCommitteeAssignmentCardsView from '../pages/bill-committee-assignment/views/cards.json';
import billCommitteeAssignmentCalendarView from '../pages/bill-committee-assignment/views/calendar.json';
import billCommitteeAssignmentDashboardView from '../pages/bill-committee-assignment/views/dashboard.json';

/** Тип запису «Передання до комітету» зі сторінками пакета: меню, форми та подання з pages/bill-committee-assignment/. */
export const billCommitteeAssignmentDefinition: IRecordTypeDefinition = {
  ...billCommitteeAssignmentEntity,
  views: assembleViewSet({
      table: billCommitteeAssignmentTableView,
      cards: billCommitteeAssignmentCardsView,
      calendar: billCommitteeAssignmentCalendarView,
      dashboard: billCommitteeAssignmentDashboardView,
  }),
  form: billCommitteeAssignmentFullForm,
  forms: { full: billCommitteeAssignmentFullForm, context: billCommitteeAssignmentContextForm, mini: billCommitteeAssignmentMiniForm, lookup: billCommitteeAssignmentLookupForm },
  menu: billCommitteeAssignmentMenu,
} as IRecordTypeDefinition;
